import { post } from "@/stores/dataManager/axios/axiosIndex";
import { axiosType } from "../../dataStore/memoryStore/const/constIndex"
import { getConfigFromWindowBrowser } from "@/utilities/utils";
import { ENV } from "@/utilities/EWindow";
const API = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''

const apiType = axiosType.CLIENT

const authService = {
    init2FactorAuth(params: { config?: object } | any) {
        const options: any = {}
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/twofactorauth/init`, options, config);
    },

    resendOTP(params: { config?: object, body: any } | any) {
        const config: any = params?.config
        const body: any = params?.body ?? {}
        return post(apiType, `${API}/cosapi/twofactorauth/resend`, body, config);
    },
};



export default authService;